package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Loan_payment(
  public val id: String,
  public val loan_id: String,
  public val amount: Long,
  public val date: String,
  public val account_id: String,
  public val tx_id: String?,
  public val note: String?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
